import React from 'react';
import PropTypes from 'prop-types';
import { format } from 'date-fns';
import { getPlayerExternalLink, livePlayer } from 'components/live-player';
import { getHoleExternalLink, liveHole } from 'components/live-hole';
import { mapActionTypeToImage } from './enums';

class ActionPost extends React.Component {
    onClickPlayer = (event) => {
        if (this.props.targetUrl) return;

        const { player } = this.props.model;

        livePlayer.show(player.playerId);
        event.preventDefault();
    }

    onClickHole = (event) => {
        if (this.props.targetUrl) return;

        const { hole } = this.props.model;

        liveHole.show(hole.holeNumber);
        event.preventDefault();
    }

    render() {
        const { model, datePublished, targetUrl } = this.props;
        const { hole, player } = model;
        const actionImageSrc = mapActionTypeToImage(model.type);
        const fullname = player ? `${player.firstName} ${player.lastName}` : '';
        let playerUrl = null;
        let holeUrl = null;


        if (targetUrl && player) {
            playerUrl = getPlayerExternalLink(targetUrl, player.playerId);
        }

        if (targetUrl && hole) {
            holeUrl = getHoleExternalLink(targetUrl, hole.holeNumber);
        }

        return (
            <div className={`action-post action-post--${model.type}`}>
                {
                    datePublished &&
                    <div className="action-post__pubdate">{format(datePublished, 'h:mm a')}</div>
                }
                <div className="action-post__action">
                    {
                        actionImageSrc &&
                        <img
                            key={actionImageSrc}
                            className="action-post__action-icon lazyload"
                            data-src={actionImageSrc}
                            width="60"
                            height="60"
                            alt=""
                        />
                    }
                    <p className="action-post__action-title">{model.label}</p>
                </div>
                <div className="action-post__content">
                    <h3 className="action-post__heading">{model.title}</h3>
                    <div className="action-post__body" dangerouslySetInnerHTML={{ __html: model.body }} />
                    <div className="action-post__links">
                        {
                            hole &&
                            <a
                                className="action-post__link"
                                href={holeUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                onClick={this.onClickHole}
                                aria-label={`Show info in popup for hole ${hole.holeNumber}`}
                            >Hole {hole.holeNumber}</a>
                        }
                        {
                            player &&
                            <a
                                className="action-post__link"
                                href={playerUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                onClick={this.onClickPlayer}
                                aria-label={`Show info in popup for ${fullname}`}
                            >{player.lastName}</a>
                        }
                    </div>
                </div>
                {
                    player &&
                    player.cutoutSrc &&
                    <a
                        className="action-post__player"
                        href={playerUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={this.onClickPlayer}>
                        <img className="lazyload" src={player.cutoutSrc} width="56" height="68" alt="" />
                    </a>
                }
            </div>
        );
    }
};

ActionPost.propTypes = {
    model: PropTypes.object.isRequired,
    datePublished: PropTypes.string
};

export default ActionPost;
